import type { B2bPortalRight } from '@/enums/B2bPortalRight'

export function vuexPortalRights(rootState: { auth?: { permissions?: { rights?: unknown } } }): string[] | null {
  const r = rootState?.auth?.permissions?.rights
  return Array.isArray(r) ? (r as string[]) : null
}

export function vuexHasPortalRight(rootState: unknown, right: B2bPortalRight): boolean {
  return !!vuexPortalRights(rootState as { auth?: { permissions?: { rights?: unknown } } })?.includes(right)
}

export function vuexHasAnyPortalRight(rootState: unknown, rights: B2bPortalRight[]): boolean {
  const r = vuexPortalRights(rootState as { auth?: { permissions?: { rights?: unknown } } })
  if (!r) return false
  return rights.some((right) => r.includes(right))
}
